module.exports = __webpack_public_path__ + "static/media/trash.1627e65f.svg";